import styled from 'styled-components'
import { ResultJobsDto } from '../../../models/Dto/ResultJobsDto'

interface Props {
  setIsPopup: (isPopup: boolean) => void
  posterUrl: string
}

function ResultJobsPopup(props: Props) {
  const { setIsPopup, posterUrl } = props

  return (
    <PopupContainer onClick={() => setIsPopup(false)}>
      <Content>
        <img src={posterUrl} alt="" />
      </Content>
    </PopupContainer>
  )
}

const PopupContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

const Content = styled.div`
  img {
    object-fit: contain;
    object-position: center;
    width: 90vh;
    height: 90vh;
  }
`
export default ResultJobsPopup
